<template lang="pug">
multiselect(
    :options="productList",
    :multiple="multiple",
    :value="value",
    @select="onSelect",
    track-by="id",
    :custom-label="customLabel"
    :placeholder="placeholder",
    @search-change="searchProducts",
    :loading="onLoading('fetch-product')",
    :show-labels="false"
)
    template(slot="singleLabel", slot-scope="props")
        .row
            .col-md-12
                img.w-40.img-responsive.pull-left.m-r-md(:src="productImg(props.option)")
                span.clear._500 {{ props.option.name }}
                span.text-muted.clear {{ props.option.code }}

    template(slot="option", slot-scope="props")
        .row
            .col-md-12
                img.w-40.img-responsive.pull-left.m-r-md(:src="productImg(props.option)")
                span.clear._500 {{ props.option.name }}
                span.text-muted.clear {{ props.option.code }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductMixin from '@js/mixins/products';

export default {
    mixins: [ProductMixin],

    props: {
        value: {
            type: Object,
            default: () => null,
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        excludePricebook: {
            type: Number,
            default: null,
        },

        placeholder: {
            type: String,
            default: 'Search product by name or code',
        },
    },

    computed: {
        ...mapGetters('product', ['productList']),
    },

    mounted() {
        if (!this.productList.length) {
            this.getData();
        }
    },

    methods: {
        ...mapActions('product', ['getProductList']),

        customLabel(option) {
            return `${option.name} — ${option.code}`;
        },

        onSelect(product) {
            this.$emit('input', product);
        },

        searchProducts: _.debounce(function(query) {
            const params = {
                query,
                exclude_pricebook: this.excludePricebook,
            };

            this.getProductList(params);
        }),

        getData() {
            const params = {
                query: '',
                exclude_pricebook: this.excludePricebook,
            };

            this.getProductList(params);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/product-selector.vue